import { Autocomplete, TextField } from '@mui/material';
import { useIntelligenceItemCategories } from '../useIntelligenceItemCategories';
import { useController } from 'react-hook-form';

export function CategoriesController({ name, control, label }) {
  const {
    query: { data: categories },
  } = useIntelligenceItemCategories();
  const {
    field: { value, onChange, ref },
    fieldState: { error, invalid },
  } = useController({
    name,
    control,
  });

  function renderInput(params) {
    return (
      <TextField
        inputRef={ref}
        label={label}
        error={invalid}
        helperText={error?.message}
        {...params}
      />
    );
  }

  function handleChange(_, selections) {
    onChange(selections.map((selection) => selection.value ?? selection));
  }

  return (
    <Autocomplete
      value={value}
      size="small"
      fullWidth
      multiple
      freeSolo
      // selectOnFocus={selectOnFocus}
      // clearOnBlur={clearOnBlur}
      // handleHomeEndKeys={handleHomeEndKeys}
      onChange={handleChange}
      options={categories ?? []}
      renderInput={renderInput}
    />
  );
}
